import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

const TextInput = ({ name, error, touched, type = 'text', options = null }) => {
  return (
    <Field
      name={name}
      type={type}
      className={error ? 'error' : touched && 'valid'}
      placeholder={options?.placeholder}
    />
  );
};

export default TextInput;

TextInput.propTypes = {
  name: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.bool,
  type: PropTypes.string,
  options: PropTypes.object,
};
